<template>
    <span
        v-if="status === 2"
        class="badge bg-secondary"
        v-bind="$attrs"
    >Wacht op vraagouder</span>
    <span
        v-if="status === 3"
        class="badge bg-success"
        v-bind="$attrs"
    >Geaccepteerd</span>
</template>

<script>

export default {
    name: 'GastouderStatusBadge',
    inheritAttrs: false,
    props:  [
        'status',
    ],
}

</script>